import { LoadState } from '@ally/use-data-domain';
import { getAllAccounts, getDataLoadState } from './base';
/**
 * Returns `true` if the loading of accounts has failed or if there's no account
 * summary for the given account type.
 */
function isAccountOutage(type) {
    return function (data) {
        var _a, _b;
        var hasLoaded = getDataLoadState(data) === LoadState.LOADED;
        var hasFailed = getDataLoadState(data) === LoadState.FAILED;
        var accountData = (_a = getAllAccounts(data)) === null || _a === void 0 ? void 0 : _a[type];
        return (hasFailed || (hasLoaded && (!accountData || !!((_b = accountData.errors) === null || _b === void 0 ? void 0 : _b.length))));
    };
}
export var isBankOutage = isAccountOutage('deposit');
export var isInvestOutage = isAccountOutage('invest');
//# sourceMappingURL=outage.js.map